import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { css } from '@emotion/core';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Form, Table, Radio, Carousel, Modal, Select, Popover, Switch, Input, Divider } from 'antd';
import moment from 'moment';
import ReactStars from 'react-stars/dist/react-stars';

import { SettingsFormHeader } from '../../common/SettingsFormHeader';
import SubscriptionPlanCard from './SubscriptionPlanCard';
import eNums from '../../../constants/enums';
import IconSvg from '../../common/IconSvg';
import Button from '../../common/Button';
import { config } from './config';
import { FormItem, PlansContainer, MySubContainer } from './styled';
import { Arrow, InfoText } from '../../common/styled';
import Checkout from '../../Checkout';
import { colors } from '../../../constants';
import SubscriptionAddons from './SubscriptionAddons';
import Spinner from '../../../components/common/spinner';
import ConditionalWrapper from '../../../HOC/ConditionalWrapper';
import { text1 } from '../../../constants/classes';
import SubscriptionCustomPlanCard from './SubscriptionCustomPlanCard';
import { CustomPlan } from '../../OnboardingScreens/Screen6';
import { tripleMarsHelpUrl } from '../../../utils/getEnvUrl';

const { Option } = Select;
// const { OptGroup }=Select;
const { formItemLayout, slidesToScroll, slidesToShow } = config;
// const { warning } = Modal;
const { WARNING } = eNums.TOAST_TYPES;

@injectIntl
@Form.create()
@inject('settingsStore')
@inject('localeStore')
@inject('routingStore')
@inject('toastsStore')
@observer
class Subscription extends Component {
  constructor() {
    super();
    this.carouselRef = React.createRef();
    this.state = {
      seeAllBillings: false,
      isMonthlyPayment: true,
      hoveringCardVisible: false,
      clickedPlanIndex: -1,
      goodbyeIndex: -1,
      showCheckout: false,
      payPalConnectionLoading: false,
      initialSlide: null,
      modalContentRef: document.getElementById('tm-settings-modal-content'),
      disableUpgradePlan: false,
      goodbyeModalVisible: false,
      otherImprovement: null,
      otherReason: null,
      clickedPlanBCR: null,
    };
    this.closeCard = this.closeCard.bind(this);
    this.cancelSubscription = this.cancelSubscription.bind(this);
  }

  componentDidMount() {
    const {
      updateBreadcrumbs,
      intl,
      settingsStore: {
        subscription: { currentPlanId, displayedPlans },
      },
    } = this.props;
    const { modalContentRef } = this.state;
    updateBreadcrumbs(
      {
        name: intl.formatMessage({ id: 'settingsModal.subscription' }),
      },
      true,
    );
    const actualModalContentRef =
      modalContentRef ?? document.getElementById('tm-settings-modal-content');
    const currPlanIndex = displayedPlans
      .filter(
        plan =>
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY,
      )
      .findIndex(p => p.id === currentPlanId);
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      initialSlide: currPlanIndex === -1 ? 0 : currPlanIndex,
      disableUpgradePlan: currentPlanId === eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY,
      modalContentRef: actualModalContentRef,
    });
    const parts = window.location.hash.slice(1).split('-');
    if (parts[1]) {
      this.handlePlanCardClick(null, parts[1]);
    }
  }

  onPaymentMethodChange = e => {
    const val = e.target.value;
    this.setState({ isMonthlyPayment: val === 1 });
  };

  getStripeSelectValue = (accounts, id) => {
    const filtered =
      accounts.length > 0
        ? accounts
          .map(item => item.cards.find(card => card.id === id))
          .filter(item => item !== undefined)
        : '';
    const value = filtered[0] !== undefined ? `**** ${filtered[0].last4Digits}` : '';
    return value;
  };

  getPayoneerSelectValue = (accounts, id) => {
    return accounts.find(acc => acc.id === id)?.name ?? '';
  };

  setGoodbyeIndex = idx => {
    this.setState({ goodbyeIndex: idx });
  };

  setOtherImprovement = v => {
    this.setState({ otherImprovement: v });
  };

  setOtherReason = v => {
    this.setState({ otherReason: v });
  };

  toggleGoodbyeModalVisible = (force = null) => {
    const { goodbyeModalVisible } = this.state;
    if (force === null) {
      this.setState({
        goodbyeModalVisible: !goodbyeModalVisible,
      });
    } else {
      this.setState({
        goodbyeModalVisible: force,
      });
    }
    // if below method fails or gets changed, delete it and add '#hs-chat-open' to the url
    window.$zoho.salesiq.chat.start();
  };

  loadURLPlan = urlPlanId => {
    const {
      settingsStore: {
        subscription: { displayedPlans, setBIFMCatalogOn, BIFMCatalogOn },
      },
    } = this.props;
    let hashPlanIndex = displayedPlans
      .filter(
        plan =>
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY,
      )
      .findIndex(p => p.id === urlPlanId);
    if (hashPlanIndex !== -1) {
      return hashPlanIndex;
    } // else
    setBIFMCatalogOn(!BIFMCatalogOn);
    const {
      settingsStore: {
        subscription: { displayedPlans: updatedDisplayedPlans },
      },
    } = this.props;
    hashPlanIndex = updatedDisplayedPlans
      .filter(
        plan =>
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY,
      )
      .findIndex(p => p.id === urlPlanId);
    return hashPlanIndex;
  };

  paypalInput = null;

  columns = [
    {
      title: 'Last Billing Period',
      dataIndex: 'paymentDatetime',
      key: 'paymentDatetime',
      render: text => moment(text).format('MMM-DD-YYYY HH:mm'),
    },
    {
      title: 'Billing Number',
      dataIndex: 'transactionId',
      key: 'transactionId',
    },
    {
      title: 'Billing Total',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Invoice',
      dataIndex: 'invoiceId',
      key: 'invoiceId',
      render: text => (
        <span
          onClick={text ? () => this.props.settingsStore.subscription.fetchInvoice(text) : null}
          style={{ cursor: text ? 'pointer' : 'not-allowed' }}
        >
          <ConditionalWrapper
            condition={!text}
            wrapper={v => (
              <Popover title="" content={<FormattedMessage id="common.checkTomorrow" />}>
                {v}
              </Popover>
            )}
          >
            <IconSvg type={text ? 'pdf-file' : 'clock'} />
          </ConditionalWrapper>
        </span>
      ),
    },
  ];

  hasErrors = fieldsError => Object.keys(fieldsError).some(field => fieldsError[field]);

  openHelpPage = () => {
    const newWindow = window.open(tripleMarsHelpUrl, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  closeAccount = () => {
    const {
      settingsStore: {
        subscription: { goodbyeAnswers, sendGoodbyeAnswers },
      },
    } = this.props;
    goodbyeAnswers.setAction('close account');
    goodbyeAnswers.setRate(5);
    sendGoodbyeAnswers();
  };

  cancelSubscription = () => {
    const {
      // intl,
      settingsStore: {
        subscription: { goodbyeAnswers, sendGoodbyeAnswers },
      },
    } = this.props;
    goodbyeAnswers.setAction('cancel subscription');
    goodbyeAnswers.setRate(5);
    sendGoodbyeAnswers();
  };
  closeCard = () => {
    this.setState({
      hoveringCardVisible: false,
    });
  };

  closeCardAndScrollTop = () => {
    const { modalContentRef } = this.state;
    this.setState(
      {
        hoveringCardVisible: false,
      },
      () => {
        modalContentRef.scrollTop = 0;
      },
    );
  };

  openCard = (index = -1, bcr) => {
    this.setState(
      {
        clickedPlanIndex: index,
        hoveringCardVisible: true,
        clickedPlanBCR: bcr,
      },
      () => {
        if (bcr) {
          const element = document.querySelector(`#tm-popped-over-plan-card`);
          element.children[0].className = element.children[0].className.replace(
            /\btm-plan-initial-pos\b/g,
            '',
          );
        }
      },
    );
  };

  handlePlanCardClick = (index, id) => {
    const bcr = document.querySelector(`#tm-${id}-card`)?.getBoundingClientRect();
    let actualIndex = index;
    if (typeof index !== 'number' && !index) {
      actualIndex = this.loadURLPlan(id);
    }
    const {
      routingStore: { browserHistory },
    } = this.props;
    this.openCard(actualIndex, bcr);
    const parts = window.location.hash.slice(1).split('-');
    if (parts[1] !== id) {
      browserHistory.push(`${window.location.pathname}#subscription-${id}`);
    }
  };

  confirmPlanChange = (planId, addOns,purchaseId) => {
    const {
      settingsStore: {
        subscription: { upgradePlan, currentPlanId },
      },
      refreshSubscriptionClone,
    } = this.props;
    if (currentPlanId !== planId) {
      upgradePlan(planId, addOns, purchaseId).then(() => {
        refreshSubscriptionClone();
      });
    }
    this.setState({
      hoveringCardVisible: false,
    });
  };
  updateAccount = (value, isPreferred) => {
    const {
      settingsStore: {
        subscription: {
          updateBillingPaypalAccount,
          fetchBillingPaypalAccount,
          fetchBillingPayoneerAccount,
          fetchBillingStripeAccount,
        },
      },
    } = this.props;

    if (value) {
      updateBillingPaypalAccount(value, isPreferred).then(() => {
        fetchBillingPaypalAccount();
        fetchBillingPayoneerAccount();
        fetchBillingStripeAccount();
      });
    } else {
      this.setState({ showCheckout: true });
    }
  };

  paypalDefaultAccount = (value, isPreferred) => {
    const {
      settingsStore: {
        subscription: {
          updateBillingPaypalAccount,
          fetchBillingPaypalAccount,
          fetchBillingPayoneerAccount,
          fetchBillingStripeAccount,
          billingPaypalAccountId,
          billableAccounts,
        },
      },
      toastsStore,
    } = this.props;
    if (!billableAccounts.find(acc => acc.id === billingPaypalAccountId)) {
      toastsStore.showToast({
        type: WARNING,
        message: 'No paypal account connected!',
      });
    } else {
      updateBillingPaypalAccount(value, isPreferred).then(() => {
        fetchBillingPaypalAccount();
        fetchBillingPayoneerAccount();
        fetchBillingStripeAccount();
      });
    }
  };

  updatePayoneerAccount = (value, isPreferred) => {
    const {
      settingsStore: {
        subscription: {
          updateBillingPayoneerAccount,
          fetchBillingPayoneerAccount,
          fetchBillingPaypalAccount,
          fetchBillingStripeAccount,
        },
        connectionManagement: { connectPayoneerAccount },
      },
    } = this.props;

    if (value) {
      updateBillingPayoneerAccount(value, isPreferred).then(() => {
        fetchBillingPayoneerAccount();
        fetchBillingPaypalAccount();
        fetchBillingStripeAccount();
      });
    } else {
      connectPayoneerAccount();
    }
  };

  payoneerDefaultAccount = (value, isPreferred) => {
    const {
      settingsStore: {
        subscription: {
          updateBillingPayoneerAccount,
          fetchBillingPayoneerAccount,
          fetchBillingPaypalAccount,
          fetchBillingStripeAccount,
          billablePayoneerAccounts,
          billingPayoneerAccountId,
        },
      },
      toastsStore,
    } = this.props;
    if (!billablePayoneerAccounts.find(acc => acc.id === billingPayoneerAccountId)) {
      toastsStore.showToast({
        type: WARNING,
        message: 'No payoneer account connected!',
      });
    } else {
      updateBillingPayoneerAccount(value, isPreferred).then(() => {
        fetchBillingPayoneerAccount();
        fetchBillingPaypalAccount();
        fetchBillingStripeAccount();
      });
    }
  };

  updateStripeAccount = (value, isPreferred) => {
    const {
      settingsStore: {
        subscription: {
          updateBillingStripeAccount,
          fetchBillingStripeAccount,
          fetchBillingPayoneerAccount,
          fetchBillingPaypalAccount,
        },
        connectionManagement: { connectStripeAccount },
      },
    } = this.props;

    if (value) {
      updateBillingStripeAccount(value, isPreferred).then(() => {
        fetchBillingStripeAccount();
        fetchBillingPayoneerAccount();
        fetchBillingPaypalAccount();
      });
    } else {
      connectStripeAccount();
    }
  };

  stripeDefaultAccount = (value, isPreferred) => {
    const {
      settingsStore: {
        subscription: {
          updateBillingStripeAccount,
          fetchBillingStripeAccount,
          fetchBillingPayoneerAccount,
          fetchBillingPaypalAccount,
          billableStripeAccounts,
          billingStripeAccountId,
        },
      },
      toastsStore,
    } = this.props;
    if (
      !billableStripeAccounts.filter(item =>
        item.cards.find(card => card.id === billingStripeAccountId),
      )
    ) {
      toastsStore.showToast({
        type: WARNING,
        message: 'No Stripe account connected!',
      });
    } else {
      updateBillingStripeAccount(value, isPreferred).then(() => {
        fetchBillingStripeAccount();
        fetchBillingPayoneerAccount();
        fetchBillingPaypalAccount();
      });
    }
  };

  goToSlide = () => {
    this.carouselRef.current.goTo(6);
  };

  render() {
    const {
      intl,
      localeStore: { isJA },
      settingsStore: {
        subscription: {
          sendGoodbyeAnswers,
          goodbyeAnswers,
          currentPlanId,
          currentPlan,
          activeAddOnsMap,
          updateBillingPaypalAccount = console.log,
          displayedPlans,
          sortedPayments,
          billingPaypalAccountId,
          // isPaypalPreferred,
          billingPayoneerAccountId,
          isPayoneerPreferred,
          billingStripeAccountId,
          // isStripePreferred,
          // billableAccounts,
          billablePayoneerAccounts,
          // billableStripeAccounts,
          loading,
          BIFMCatalogOn,
          setBIFMCatalogOn,
          canCancel,
          // isStripeDisabled,
          // isPaypalDisabled
          setIsCourseModalOpen,
          userHasCourse,
          addOns
        },
        userProfile: { firstName, lastName, phoneNumber, isNonApi, onBoardingLevel },
      },
      selectTab,
      updateApplyBtn,
      subscriptionClone,
    } = this.props;
    const {
      hoveringCardVisible,
      clickedPlanIndex,
      seeAllBillings,
      isMonthlyPayment,
      showCheckout,
      payPalConnectionLoading,
      initialSlide,
      disableUpgradePlan,
      goodbyeIndex,
      // goodbyeModalVisible,
      otherImprovement,
      otherReason,
      clickedPlanBCR,
    } = this.state;

    const clickedPlan =
      displayedPlans.filter(
        plan =>
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY,
      )[clickedPlanIndex] || null;
    let hoveringCardAction = this.confirmPlanChange;
    let hoveringCardButtonMessage = intl.formatMessage({ id: 'subscription.agree' });

    const requiredData = [
      {
        type: 'firstName',
        value: firstName,
      },
      {
        type: 'lastName',
        value: lastName,
      },
      {
        type: 'phoneNumber',
        value: phoneNumber,
      },
    ];

    // payoneer has priority over paypal if both payments connected
    const billingAccount = billingPayoneerAccountId || billingPaypalAccountId || billingStripeAccountId ?? '';

    const courseAddOns = addOns.filter(x => x.id === "course")[0]?.plans;

    // this is an extreme scenario if the user has no payment option
    if (!billingAccount) {
      requiredData.push(
        {
          type: 'billingPaypalAccountId',
          value: billingPaypalAccountId,
        },
        {
          type: 'billingPayoneerAccountId',
          value: billingPayoneerAccountId,
        },
        {
          type: 'billingStripeAccountId',
          value: billingStripeAccountId,
        },
      );
      hoveringCardAction = this.closeCardAndScrollTop;
      hoveringCardButtonMessage = intl.formatMessage({ id: 'common.cancel' });
    }
    if (!firstName || !lastName || !phoneNumber) {
      hoveringCardAction = () => selectTab(eNums.SETTINGS_TABS.USER_PROFILE);
      hoveringCardButtonMessage = intl.formatMessage({ id: 'subscription.updateUserProfile' });
    }

    return (
      <Form className="login-form" layout="vertical">
        <SettingsFormHeader
          key="billing-info-header"
          id="subscription.billingInformation"
          defaultMessage="BILLING INFORMATION"
        />
        {showCheckout ? (
          <div>
            <Checkout
              beforeConnect={() => {
                this.setState({
                  payPalConnectionLoading: true,
                });
              }}
              afterConnect={acc => {
                updateBillingPaypalAccount(acc.id);
                this.setState({
                  payPalConnectionLoading: false,
                  showCheckout: false,
                });
              }}
            />
          </div>
        ) : (
          <div>
            {/* <FormItem
              key="paypal-account"
              {...formItemLayout}
              label={intl.formatMessage({ id: 'subscription.paypalAccount' })}
            >
              <div
                css={css`
                  display: flex;
                `}
              >
                <Select
                  onChange={value => this.updateAccount(value, isPaypalPreferred)}
                  value={
                    billableAccounts.length > 0
                      ? billableAccounts.find(acc => acc.id === billingPaypalAccountId)?.name
                      : ''
                  }
                  style={{ maxWidth: 'calc(100% - 18px)', minWidth: '150px' }}
                  disabled={isPaypalDisabled || onBoardingLevel !== 'done onboarding'}
                >
                  {billableAccounts.map(({ id, name }) => (
                    <Option key={id} value={id}>
                      {name}
                    </Option>
                  ))}
                  <Option key="other" value="">
                    <span style={{ fontFamily: 'Heebo-Thin' }}>
                      {intl.formatMessage({ id: 'listing.connectAnother' })}
                    </span>
                  </Option>
                </Select>
                <Button
                  type="normal"
                  clickHandler={() => {
                    this.paypalDefaultAccount(billingPaypalAccountId, !isPaypalPreferred);
                  }}
                  css={css`
                    margin-left: 22px;
                    height: 22px;
                  `}
                  disabled={isPaypalPreferred || isPaypalDisabled || onBoardingLevel !== 'done onboarding'}
                >
                  Set as default
                </Button>
              </div>
            </FormItem> */}
            <FormItem
              key="payoneer-account"
              {...formItemLayout}
              label={intl.formatMessage({ id: 'subscription.payoneerAccount' })}
            >
              <div
                css={css`
                  display: flex;
                `}
              >
                <Select
                  onChange={value => this.updatePayoneerAccount(value, isPayoneerPreferred)}
                  value={this.getPayoneerSelectValue(
                    billablePayoneerAccounts,
                    billingPayoneerAccountId,
                  )}
                  style={{ maxWidth: 'calc(100% - 18px)', minWidth: '150px' }}
                >
                  {billablePayoneerAccounts.map(({ id, name }) => (
                    <Option key={id} value={id}>
                      {name}
                    </Option>
                  ))}
                  <Option key="other" value="">
                    <span style={{ fontFamily: 'Heebo-Thin' }}>
                      {intl.formatMessage({ id: 'listing.connectAnother' })}
                    </span>
                  </Option>
                </Select>
                <Button
                  type="normal"
                  clickHandler={() => {
                    this.payoneerDefaultAccount(billingPayoneerAccountId, !isPayoneerPreferred);
                  }}
                  css={css`
                    margin-left: 22px;
                    height: 22px;
                  `}
                  disabled={isPayoneerPreferred || onBoardingLevel !== 'done onboarding'}
                >
                  Set as default
                </Button>
              </div>
            </FormItem>

            {/* <FormItem
              key="stripe-account"
              {...formItemLayout}
              label={intl.formatMessage({ id: 'subscription.stripeAccount' })}
            >
              <Popover title="" content="Credit card payments are temporarily disabled.">
                <div
                  css={css`
                    display: flex;
                  `}
                >
                  <Select
                    onChange={value => this.updateStripeAccount(value, isStripePreferred)}
                    value={this.getStripeSelectValue(
                      billableStripeAccounts,
                      billingStripeAccountId,
                    )}
                    style={{ maxWidth: 'calc(100% - 18px)', minWidth: '150px' }}
                    disabled={isStripeDisabled || onBoardingLevel !== 'done onboarding'}
                  >
                    {billableStripeAccounts.map(item => (
                      <OptGroup key={item.email} label={item.email}>
                        {item.cards.map(card => (
                          <Option key={card.id} value={card.id}>
                            <span>**** {card.last4Digits}</span>
                          </Option>
                        ))}
                      </OptGroup>
                    ))}
                    <Option key="other" value="">
                      <span style={{ fontFamily: 'Heebo-Thin' }}>
                        {intl.formatMessage({ id: 'listing.connectAnother' })}
                      </span>
                    </Option>
                  </Select>
                  <Button
                    type="normal"
                    clickHandler={() => {
                      this.stripeDefaultAccount(billingStripeAccountId, !isStripePreferred);
                    }}
                    css={css`
                      margin-left: 22px;
                      height: 22px;
                    `}
                    disabled={
                      isStripePreferred || isStripeDisabled || onBoardingLevel !== 'done onboarding'
                    }
                  >
                    Set as default
                  </Button>
                </div>
              </Popover>
            </FormItem> */}
          </div>
        )}

        <SettingsFormHeader
          key="my-plan-header"
          id="subscription.mySubscriptionPlan"
          defaultMessage="MY SUBSCRIPTION PLAN"
        />
        {!isNonApi && (
          <div
            css={css`
              display: flex;
            `}
          >
            <h2
              css={css`
                ${text1};
                margin-right: 10px;
              `}
            >
              {intl.formatMessage({ id: 'subscription.BIFMLabel' })}
            </h2>
            <Switch onChange={setBIFMCatalogOn} checked={BIFMCatalogOn} />
          </div>
        )}
        {/* check if there are any custom plans and display button to scroll carousel to custom plan  */}
        {displayedPlans.some(plan => plan.maxListedItems > 10000) && (
          <CustomPlan goToSlide={this.goToSlide} />
        )}
        {
          // <div key="usage">
          //   <FormattedMessage
          //     id="subscription.currentPeriodUsage"
          //     defaultMessage="Current Period Usage"
          //   />
          //   (Aug 14 - Sep 13)
          //   <ProgressContainer style={{ display: 'flex', justifyContent: 'stretch' }}>
          //     <ProgressCard
          //       title="Items"
          //       value={subscriptionData.itemsNumber}
          //       max={currentPlan ? currentPlan.maxItems : 0}
          //     />
          //     <ProgressCard
          //       title="Orders"
          //       value={subscriptionData.ordersNumber}
          //       max={currentPlan ? currentPlan.maxOrders : 0}
          //     />
          //   </ProgressContainer>
          // </div>
        }
        {
          // <div>
          //   <RadioGroup onChange={this.onPaymentMethodChange} defaultValue={1}>
          //     <Radio value={1}>Mounthly Billing</Radio>
          //     <Radio value={2}>Yearly Billing</Radio>
          //   </RadioGroup>
          // </div>
        }
        <PlansContainer>
          {initialSlide !== null && (
            <Carousel
              infinite={false}
              initialSlide={initialSlide}
              ref={this.carouselRef}
              dots
              arrows
              slidesToShow={slidesToShow}
              slidesToScroll={slidesToScroll}
              css={css`
                ul.slick-dots {
                  bottom: -11px;
                  & > li > button {
                    border: 1px solid ${colors.greyInputBorder};
                    border-radius: 3px;
                    background: ${colors.whiteBackground};
                    height: 6px;
                    opacity: 1;
                  }
                  & > li.slick-active > button {
                    background: ${colors.blueMed};
                    border: 1px solid ${colors.blueMed};
                  }
                }
                .slick-list {
                  padding-top: 11px;
                }
              `}
              nextArrow={<Arrow type="carousel-arrow-r" />}
              prevArrow={<Arrow flip type="carousel-arrow-r" />}
            >
              {displayedPlans
                .filter(
                  plan =>
                    plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
                    plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY &&
                    plan.maxListedItems <= 10000,
                )
                .map((plan, index) => {
                  return (
                    <SubscriptionPlanCard
                      key={`plan-card-${plan.id}`}
                      selectedPlanCost={currentPlan ? currentPlan.monthlyCost || 0 : 0}
                      plan={plan}
                      selected={plan.id === currentPlanId}
                      upgradePlan={() => this.handlePlanCardClick(index, plan.id)}
                      monthlyPayment={isMonthlyPayment}
                      disableUpgrade={disableUpgradePlan}
                      isJA={isJA}
                      htmlID={`tm-${plan.id}-card`}
                      isNonApi={isNonApi}
                      billableAccounts={billingAccount}
                    />
                  );
                })}
              {/* check if there are any custom plans and load them into the carousel */}
              {displayedPlans.some(plan => plan.maxListedItems > 10000) && (
                <SubscriptionCustomPlanCard
                  displayedPlansOnboarding={displayedPlans.filter(
                    plan =>
                      plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
                      plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY,
                  )}
                  isNonApi={isNonApi}
                  upgradePlan={this.handlePlanCardClick}
                  currentPlanId={currentPlanId}
                  monthlyPayment={isMonthlyPayment}
                  disableUpgrade={disableUpgradePlan}
                  isJA={isJA}
                  billableAccounts={billingAccount}
                  planStartingIndex={displayedPlans.findIndex(plan => plan.maxListedItems > 10000)}
                />
              )}
            </Carousel>
          )}
        </PlansContainer>
        {hoveringCardVisible && clickedPlan !== null && (
          <div
            css={css`
              position: fixed;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              z-index: 1;
            `}
          >
            <div
              css={css`
                position: absolute;
                overflow: auto;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: rgba(0, 0, 0, 0.65);
                z-index: 1;
              `}
              id="subplancard_fill"
              onClick={this.closeCard}
            >
              <SubscriptionPlanCard
                key={`plan-card-${clickedPlan.id}`}
                selectedPlanCost={currentPlan ? currentPlan.monthlyCost || 0 : 0}
                plan={clickedPlan}
                selected={clickedPlan.id === currentPlanId}
                upgradePlan={hoveringCardAction}
                hoveringCardButtonMessage={hoveringCardButtonMessage}
                monthlyPayment={isMonthlyPayment}
                poppedOver
                closeCard={this.closeCard}
                recommendedPlanId={
                  clickedPlan.includesBIFMCatalog ? '' : clickedPlan.id.slice(0, -2)
                }
                openOtherPlanCard={this.handlePlanCardClick}
                clickedPlanBCR={clickedPlanBCR}
                isNonApi={isNonApi}
                hoveringCardVisible
                billableAccounts={billingAccount}
                requiredData={requiredData}
              />
            </div>
          </div>
        )}

        <FormItem key="last-bill">
          <SettingsFormHeader id="subscription.lastBilling" defaultMessage="LAST BILLING" />
          <Table
            rowKey="id"
            pagination={false}
            columns={this.columns}
            dataSource={seeAllBillings ? sortedPayments : sortedPayments.slice(0, 3)}
          />
        </FormItem>
        <div key="show-all-btn" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="normal"
            clickHandler={() => this.setState({ seeAllBillings: !seeAllBillings })}
          >
            {seeAllBillings ? 'Show less' : 'Show all'}
          </Button>
        </div>
        <div css={css`display: flex; flex-direction: column; margin-top: 1em;`}>
          <span css={css`font-size: 14px;font-weight: 600;`}>DROPSHIPPING COURSE</span>
          <Divider key='course-divider' style={{ margin: '3px 0' }} />
          <div css={css`display:flex; margin-top:10px; margin-bottom:10px;`}>
            {(courseAddOns ?? [])?.map(() => (
              userHasCourse ? <IconSvg key="courseIcon" type="v-green" size={22} marginLeft="22px" /> :
              <Button
                key="course1"
                id="btn_plan_custom"
                style={{
                  background: '#3399CC',
                  fontSize: '14px',
                  color: '#ffffff',
                  borderRadius: '12px',
                  fontFamily: 'Heebo',
                }}
                clickHandler={()=>{setIsCourseModalOpen(true)}}
              >
                <FormattedMessage id='subscription.addonCoursePurchase' />
              </Button>
            ))}
          </div>
        </div>
        {currentPlanId && currentPlanId !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL && (
          <>
            <SettingsFormHeader
              key="subscription-addons"
              id="subscription.subscriptionAddons"
              defaultMessage="SUBSCRIPTION ADD-ONS"
              marginBottom="1em"
            />
            <SubscriptionAddons
              activeAddOnsMap={activeAddOnsMap}
              subscriptionClone={subscriptionClone}
              updateApplyBtn={updateApplyBtn}
              setIsCourseModalOpen={setIsCourseModalOpen}
              userHasCourse={userHasCourse}
            />
          </>
        )}
        <MySubContainer>
          <SettingsFormHeader
            key="billing-info-header"
            id="subscription.mySubscription"
            defaultMessage="MY SUBSCRIPTION"
            marginBottom="1em"
          />
          <div style={{ marginBottom: '1em' }}>
            <Button
              cssProps={{ minWidth: '174px', marginRight: '1em' }}
              type="normal"
              key="cancel-sub-btn"
              clickHandler={canCancel ? this.cancelSubscription : this.showRequestIsPending}
              disabled={
                !currentPlanId ||
                currentPlanId === eNums.SUBSCRIPTION_PLANS.FREE_TRAIL ||
                currentPlanId === eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY
              }
            >
              <FormattedMessage
                id="subscription.cancelSubscription"
                defaultMessage="Cancel my subscription"
              />
            </Button>
            <FormattedMessage
              id="subscription.cancelSubscription_explanation"
              defaultMessage="Cancel Subscription explanation"
            />
          </div>
          <div>
            <Button
              type="normal"
              key="cancel-sub-btn"
              cssProps={{ width: '174px', marginRight: '1em' }}
              clickHandler={this.closeAccount}
            >
              <FormattedMessage id="subscription.closeAccount" defaultMessage="Close my Account" />
            </Button>
            <FormattedMessage
              id="subscription.closeAccount_explanation"
              defaultMessage="Close Subscription explanation"
            />
          </div>
        </MySubContainer>
        <Modal
          isClosable
          destroyOnClose
          title={goodbyeAnswers.actionName}
          // disable the goodbye modal while we test opening hubspot chat
          // @todo depending on Itsik's answer, we can delete this modal
          // visible={goodbyeModalVisible}
          visible={false}
          height
          footer={null}
          onCancel={() => {
            this.toggleGoodbyeModalVisible(false);
            this.setGoodbyeIndex(-1);
            goodbyeAnswers.reset();
          }}
        >
          <div
            css={css`
              padding: 0 1em 2em 1em;
            `}
          >
            <Carousel
              ref={this.carouselRef}
              // dots
              // arrows
              infinite={false}
              slidesToShow={1}
              slidesToScroll={1}
              afterChange={idx => this.setGoodbyeIndex(idx)}
            >
              <div>
                <InfoText>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    Dear Valued Triplemars Customer,
                  </div>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    We are sorry to see you leave the TripleMars Family
                  </div>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    In order to process your request, please fill the following questionnaire and
                    our team will contact you as soon as possible.
                  </div>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    Thank you in advance for your cooperation,
                  </div>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    TripleMars Team.
                  </div>
                </InfoText>
              </div>
              <div>
                <InfoText>1. How would you rate your customer experience?</InfoText>
                <ReactStars
                  half={false}
                  count={5}
                  value={goodbyeAnswers.rate}
                  onChange={goodbyeAnswers.setRate}
                  size={23}
                  color1={colors.disabledButton}
                  color2={colors.blueDark}
                />
                <InfoText>2. What can we improve ?</InfoText>
                <Radio.Group
                  value={goodbyeAnswers.improvements}
                  onChange={({ target: { value } }) => {
                    if (value === null) {
                      this.setOtherImprovement('');
                      goodbyeAnswers.setImprovements('');
                    } else {
                      goodbyeAnswers.setImprovements(value);
                    }
                  }}
                  css={css`
                    display: flex !important;
                    flex-direction: column;
                    align-items: flex-start;
                  `}
                >
                  <Radio value="Our services">Our services</Radio>
                  <Radio value="Our customer support">Our customer support</Radio>
                  <Radio value="The system convenience">The system convenience</Radio>
                  <Radio value="The system learning">The system learning</Radio>
                  <Radio value={otherImprovement}>
                    Other:{' '}
                    <Input
                      onFocus={() => {
                        if (otherImprovement === null) {
                          this.setOtherImprovement('');
                        }
                      }}
                      onBlur={() => {
                        if (otherImprovement === '') {
                          this.setOtherImprovement(null);
                        }
                      }}
                      onChange={({ target: { value } }) => {
                        goodbyeAnswers.setImprovements(value);
                        this.setOtherImprovement(value);
                      }}
                    />
                  </Radio>
                </Radio.Group>
                <InfoText>
                  3. What was the main reason you chose to leave the TripleMars Family?
                </InfoText>
                <Radio.Group
                  value={goodbyeAnswers.reason}
                  onChange={({ target: { value } }) => {
                    if (value === null) {
                      this.setOtherReason('');
                      goodbyeAnswers.setReason('');
                    } else {
                      goodbyeAnswers.setReason(value);
                    }
                  }}
                  css={css`
                    display: flex !important;
                    flex-direction: column;
                    align-items: flex-start;
                  `}
                >
                  <Radio value="The price was too expensive">The price was too expensive</Radio>
                  <Radio value="The system did not suit my business needs">
                    The system did not suit my business needs
                  </Radio>
                  <Radio value="The system was not convenient for me to use">
                    The system was not convenient for me to use
                  </Radio>
                  <Radio value="Switching to another system">Switching to another system</Radio>
                  <Radio value="I left the dropshipping and/or eCommerce world">
                    I left the dropshipping and/or eCommerce world
                  </Radio>
                  <Radio value="My eBay / PayPal account has issues">
                    My eBay / PayPal account has issues
                  </Radio>
                  <Radio value={otherReason}>
                    Other:{' '}
                    <Input
                      onFocus={() => {
                        if (otherReason === null) {
                          this.setOtherReason('');
                        }
                      }}
                      onBlur={() => {
                        if (otherReason === '') {
                          this.setOtherReason(null);
                        }
                      }}
                      onChange={({ target: { value } }) => {
                        goodbyeAnswers.setReason(value);
                        this.setOtherReason(value);
                      }}
                    />
                  </Radio>
                </Radio.Group>
              </div>
              <div>
                <InfoText>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    Thank you for your kind response to our customer service questionnaire.
                  </div>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    We want to assure you that all our customers are our top priority.
                  </div>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    You will be contacted by our retention team in the next 2 business days.
                  </div>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    You are also welcome to contact us directly at sales@triplemars.com
                  </div>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    Thank you very much for your cooperation.
                  </div>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    We wish you the best.
                  </div>
                  <div
                    css={css`
                      margin-bottom: 20px;
                    `}
                  >
                    TripleMars Team.
                  </div>
                </InfoText>
              </div>
            </Carousel>
            <Button
              type="secondary"
              cssProps={css`
                margin-top: 10px;
              `}
              clickHandler={() => {
                if (goodbyeIndex < 2) {
                  this.carouselRef.current.next();
                } else {
                  sendGoodbyeAnswers();
                  goodbyeAnswers.reset();
                  this.toggleGoodbyeModalVisible(false);
                  this.setGoodbyeIndex(-1);
                }
              }}
              disabled={goodbyeIndex === 1 && !goodbyeAnswers.isValid}
            >
              {goodbyeIndex < 2 ? 'Continue' : 'Send'}
            </Button>
          </div>
        </Modal>
        {payPalConnectionLoading || (loading && <Spinner />)}
      </Form>
    );
  }
}

Subscription.propTypes = {
  intl: PropTypes.object,
  form: PropTypes.object,
  settingsStore: PropTypes.object,
  subscription: PropTypes.object,
  upgradePlan: PropTypes.func,
  updateBreadcrumbs: PropTypes.func,
  selectTab: PropTypes.func,
  updateApplyBtn: PropTypes.func,
  subscriptionClone: PropTypes.object,
  localeStore: PropTypes.object,
  refreshSubscriptionClone: PropTypes.func,
};

export default Subscription;
